<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="标题：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="报告日期：" prop="report_date">
                <el-date-picker v-model="model.report_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="报告内容：" prop="content">
                <vue-ueditor-wrap v-model="content1" :config="myConfig" editor-id="container" @ready="UEditorReady"></vue-ueditor-wrap>
            </el-form-item>
            <el-form-item label="指定审核人：" prop="zd_sh_name" v-if="model.zd_sh_id">
                <span>{{model.zd_sh_name}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="success" @click="handleSubmit(2)" size="medium">审核通过</el-button>
            <el-button type="danger" @click="handleSubmit(3)" size="medium">审核不通过</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel, getModelById } from '@/api/common'
import VueUeditorWrap from 'vue-ueditor-wrap';

export default {
    name: 'dayReportEdit',
    mixins: [editutil],
    components: {VueUeditorWrap},
    data() {
        return {
            model: {
                title: '',
                report_date: '',
                content: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                state: '0',
            },
            getObj:{
                url:'/api/admin/dayreport/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                title: [
                    {required: true, message: '标题不能为空', trigger: 'blur'}
                ],
                report_date: [
                    {required: true, message: '报告日期不能为空', trigger: 'blur'}
                ],
                content: [
                    {required: true, message: '报告内容不能为空', trigger: 'blur'}
                ],
            },
            myConfig: {
                //你的UEditor资源存放的路径,相对于打包后的index.html
                UEDITOR_HOME_URL: '/ueditor/',
                //编辑器不自动被内容撑高
                autoHeightEnabled: false,
                autoFloatEnabled: false,
                //初始容器宽度
                initialFrameWidth: '100%',
                //初始容器高度
                initialFrameHeight: 280,
            },
            content1: '',
            editor: null,
        };
    },
    methods: {
        UEditorReady() {
            this.editor = UE.getEditor('container');
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        this.content1 = this.model.content+""
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        //保存方法
        handleSubmit(state) {
            this.model.content = this.content1
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/dayreport/save'
                    }
                    this.model.state = state
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>